import { type PagingParams } from '@pkg/types/api';

type PageParam = {
    paging: PagingParams;
    data: unknown;
};

export const usersCacheKeys = {
    inviteData: ['invite-data'] as const,
};

export const getNextPageParam = <T>(lastPage: PageParam & T, pages: (PageParam & T)[]) => {
    if (lastPage && lastPage?.paging?.total && lastPage?.paging?.limit && lastPage?.paging?.page != null) {
        const total = lastPage?.paging?.total || 0;
        const limit = lastPage?.paging?.limit || 1;
        const totalPages = Math.ceil(total / limit);

        if (pages?.length < totalPages) {
            return pages?.length;
        } else {
            return undefined;
        }
    }
    return undefined;
};

export const getPagesContent = <T>(pages?: (PageParam & T)[]) =>
    (pages?.map((page) => page?.data).flat() ?? []) as unknown as (PageParam & T)['data'];

export const getPagesPagingParams = <T>(pages?: (PageParam & T)[]) => {
    const paging = pages?.map((page) => page?.paging)?.flat();
    return paging?.[paging?.length - 1 || 0] || paging?.[0] || ({ page: 0, limit: 20, total: 0 } as PagingParams);
};
